// extracted by mini-css-extract-plugin
export default {"BlogMenuComponent":"styles--BlogMenuComponent--2-8Np","menuList":"styles--menuList--6qdHb","item":"styles--item--zgWgr","item--isCurrent":"styles--item--isCurrent--3BdUQ"};